import { Component, Input, Output, EventEmitter } from '@angular/core';
import {RatingService} from "../../services/rating.service";

@Component({
  selector: 'jhi-question',
  templateUrl: './question.component.html',
  styleUrls: ['./question.component.scss']
})
export class QuestionComponent {
  @Input() question = '';
  @Input() choices: string[] = [];
  @Output() choiceSelected = new EventEmitter<number>();


  constructor(public ratingService: RatingService) {}

  toggleChoice(index: number): void {
    this.ratingService.selectedChoiceIndex = index;
    this.choiceSelected.emit(index);
  }
}
